module.exports = __webpack_public_path__ + "img/studyTwo.4854511d.png";